angular.module('purchase-frequency', ['core'])
    .constant('PurchaseFrequencyConst', {
        eventUpdate: 'purchase-frequency.updated'
    })
    .factory('PurchaseFrequency', function ($resource) {
        return $resource('/crm/api/purchase-frequency/:id', {}, {
            list: {method: 'GET', isArray: false},
            update: {method: 'PUT'},
            autocomplete: {method: 'GET', isArray: true, url: '/crm/api/purchase-frequency/autocomplete'}
        })
    })
    .service('PurchaseFrequencyService', function ($rootScope, toastr, modals, PurchaseFrequency, PurchaseFrequencyConst) {
        this.edit = entity => {
            return modals.open('app/purchase-frequency/edit-modal.html', 'PurchaseFrequencyDialogController', angular.copy(entity), {size: 'md'}, "$ctrl")
        }
        this.add = () => {
            let entity = {
                active: true,
                id: null
            }
            return this.edit(entity)
        }
        this.remove = item => {
            modals.confirmDelete(item.name, () => PurchaseFrequency.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(PurchaseFrequencyConst.eventUpdate)))
        }
    })
    .controller('PurchaseFrequencyDialogController', function ($rootScope, $uibModalInstance, data, toastr, PurchaseFrequency, PurchaseFrequencyConst) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            let promise
            if (this.item.id !== null) {
                promise = PurchaseFrequency.update(this.item).$promise
            } else {
                promise = PurchaseFrequency.save(this.item).$promise
            }
            return promise.then(result => {
                $rootScope.$broadcast(PurchaseFrequencyConst.eventUpdate)
                $uibModalInstance.close(result)
                toastr.success("Zapisano")
            })
        }
    })
    .component('purchaseFrequencyList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/purchase-frequency/list.html',
        controller: function ($scope, $state, PurchaseFrequencyService, PurchaseFrequencyConst) {
            this.reset = () => this.filters = {}
            this.PurchaseFrequencyService = PurchaseFrequencyService
            $scope.$on(PurchaseFrequencyConst.eventUpdate, () => $state.reload())
        }
    })
    .config(function ($stateProvider) {
        $stateProvider.state('purchaseFrequencyList', {
            parent: 'app',
            url: '/purchase-frequency?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': 'purchaseFrequencyList'
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (PurchaseFrequency, $stateParams) => PurchaseFrequency.list(angular.copy($stateParams)).$promise
            }
        })
    })
